import { useSelector } from 'react-redux';
import { profileTypes } from '../config/constants/userConstants';

/**
 * Determines whether the current user is allowed to create/edit/delete assets.
 *
 * Only the OPERATOR profile is restricted: it depends on the `canEditAssets`
 * flag configured on the profile. Every other profile can always edit assets.
 */
export const useCanEditAsset = () => {
  const { profileData, disableFinalCustomerDataEdition } = useSelector((state) => ({
    profileData: state.auth?.currentUser?.profile,
    disableFinalCustomerDataEdition: state.selfScheduling?.landingPageData?.disableFinalCustomerDataEdition,
  }));

  // Public contexts without a session (e.g. self-scheduling) have no profile;
  // asset creation is allowed there unless the landing page disables it.
  if (!profileData) return !disableFinalCustomerDataEdition;

  return ![profileTypes.OPERATOR.id].includes(profileData.idProfile) || profileData.canEditAssets;
};
